import {IPhoneCodeValidationConfig} from 'coreUtils/IUtils';
import {IPhoneCodeConfig} from './IPhoneField';

export const defaultPhoneValidationParams: IPhoneCodeValidationConfig = {
	minLength: 6,
	maxLength: 15,
	regexp: /^\d+$/,
};

export const phoneCodes: Array<IPhoneCodeConfig> = [
	{
		code: '+376',
		countryCode: 'AD',
	},
	{
		code: '+971',
		countryCode: 'AE'
	},
	{
		code: '+355',
		countryCode: 'AL'
	},
	{
		code: '+374',
		countryCode: 'AM'
	},
	{
		code: '+54',
		countryCode: 'AR'
	},
	{
		code: '+43',
		countryCode: 'AT',
		validation: {
			maxLength: 13,
			minLength: 4,
		}
	},
	{
		code: '+61',
		countryCode: 'AU'
	},
	{
		code: '+994',
		countryCode: 'AZ'
	},
	{
		code: '+387',
		countryCode: 'BA'
	},
	{
		code: '+32',
		countryCode: 'BE'
	},
	{
		code: '+359',
		countryCode: 'BG'
	},
	{
		code: '+973',
		countryCode: 'BH'
	},
	{
		code: '+673',
		countryCode: 'BN'
	},
	{
		code: '+55',
		countryCode: 'BR'
	},
	{
		code: '+375',
		countryCode: 'BY'
	},
	{
		code: '+501',
		countryCode: 'BZ'
	},
	{
		code: '+41',
		countryCode: 'CH'
	},
	{
		code: '+56',
		countryCode: 'CL'
	},
	{
		code: '+86',
		countryCode: 'CN',
		validation: {
			maxLength: 12,
			minLength: 10,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+57',
		countryCode: 'CO'
	},
	{
		code: '+357',
		countryCode: 'CY'
	},
	{
		code: '+420',
		countryCode: 'CZ'
	},
	{
		code: '+49',
		countryCode: 'DE',
		validation: {
			maxLength: 12,
			minLength: 8,
		}
	},
	{
		code: '+45',
		countryCode: 'DK'
	},
	{
		code: '+213',
		countryCode: 'DZ'
	},
	{
		code: '+593',
		countryCode: 'EC'
	},
	{
		code: '+372',
		countryCode: 'EE'
	},
	{
		code: '+20',
		countryCode: 'EG'
	},
	{
		code: '+34',
		countryCode: 'ES',
		validation: {
			maxLength: 12,
			minLength: 8,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+358',
		countryCode: 'FI',
		validation: {
			maxLength: 12,
			minLength: 5,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+33',
		countryCode: 'FR',
		validation: {
			maxLength: 12,
			minLength: 5,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+44',
		countryCode: 'GB',
		validation: {
			maxLength: 12,
			minLength: 9,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+995',
		countryCode: 'GE'
	},
	{
		code: '+233',
		countryCode: 'GH'
	},
	{
		code: '+350',
		countryCode: 'GI'
	},
	{
		code: '+299',
		countryCode: 'GL'
	},
	{
		code: '+30',
		countryCode: 'GR'
	},
	{
		code: '+502',
		countryCode: 'GT'
	},
	{
		code: '+852',
		countryCode: 'HK'
	},
	{
		code: '+385',
		countryCode: 'HR'
	},
	{
		code: '+36',
		countryCode: 'HU'
	},
	{
		code: '+62',
		countryCode: 'ID'
	},
	{
		code: '+353',
		countryCode: 'IE'
	},
	{
		code: '+972',
		countryCode: 'IL'
	},
	{
		code: '+91',
		countryCode: 'IN'
	},
	{
		code: '+354',
		countryCode: 'IS'
	},
	{
		code: '+39',
		countryCode: 'IT',
		validation: {
			maxLength: 12,
			minLength: 8,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+962',
		countryCode: 'JO'
	},
	{
		code: '+81',
		countryCode: 'JP',
		validation: {
			maxLength: 10,
			minLength: 9,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+996',
		countryCode: 'KG',
	},
	{
		code: '+855',
		countryCode: 'KH',
	},
	{
		code: '+82',
		countryCode: 'KR',
		validation: {
			maxLength: 10,
			minLength: 8,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+965',
		countryCode: 'KW'
	},
	{
		code: '+961',
		countryCode: 'LB'
	},
	{
		code: '+423',
		countryCode: 'LI',
		validation: {
			maxLength: 12,
			minLength: 7,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+370',
		countryCode: 'LT'
	},
	{
		code: '+352',
		countryCode: 'LU'
	},
	{
		code: '+371',
		countryCode: 'LV'
	},
	{
		code: '+212',
		countryCode: 'MA'
	},
	{
		code: '+377',
		countryCode: 'MC'
	},
	{
		code: '+373',
		countryCode: 'MD'
	},
	{
		code: '+382',
		countryCode: 'ME'
	},
	{
		code: '+389',
		countryCode: 'MK'
	},
	{
		code: '+853',
		countryCode: 'MO'
	},
	{
		code: '+230',
		countryCode: 'MS'
	},
	{
		code: '+356',
		countryCode: 'MT'
	},
	{
		code: '+52',
		countryCode: 'MX'
	},
	{
		code: '+60',
		countryCode: 'MY'
	},
	{
		code: '+258',
		countryCode: 'MZ'
	},
	{
		code: '+31',
		countryCode: 'NL'
	},
	{
		code: '+47',
		countryCode: 'NO',
		validation: {
			maxLength: 12,
			minLength: 6,
			regexp: /^((?:[- ]?\d{2,4}[- ]?){2,4})?$/
		}
	},
	{
		code: '+64',
		countryCode: 'NZ'
	},
	{
		code: '+968',
		countryCode: 'OM'
	},
	{
		code: '+51',
		countryCode: 'PE'
	},
	{
		code: '+63',
		countryCode: 'PH'
	},
	{
		code: '+48',
		countryCode: 'PL'
	},
	{
		code: '+351',
		countryCode: 'PT'
	},
	{
		code: '+595',
		countryCode: 'PY'
	},
	{
		code: '+974',
		countryCode: 'QA'
	},
	{
		code: '+40',
		countryCode: 'RO'
	},
	{
		code: '+381',
		countryCode: 'RS'
	},
	{
		code: '+7',
		countryCode: 'RU',
		validation: {
			maxLength: 10,
			minLength: 9,
		}
	},
	{
		code: '+966',
		countryCode: 'SA'
	},
	{
		code: '+46',
		countryCode: 'SE'
	},
	{
		code: '+386',
		countryCode: 'SI'
	},
	{
		code: '+421',
		countryCode: 'SK'
	},
	{
		code: '+378',
		countryCode: 'SM'
	},
	{
		code: '+65',
		countryCode: 'SG'
	},
	{
		code: '+963',
		countryCode: 'SY'
	},
	{
		code: '+66',
		countryCode: 'TH'
	},
	{
		code: '+992',
		countryCode: 'TJ'
	},
	{
		code: '+216',
		countryCode: 'TN'
	},
	{
		code: '+90',
		countryCode: 'TR'
	},
	{
		code: '+886',
		countryCode: 'TW'
	},
	{
		code: '+380',
		countryCode: 'UA'
	},
	{
		code: '+1',
		countryCode: 'US'
	},
	{
		code: '+998',
		countryCode: 'UZ'
	},
	{
		code: '+379',
		countryCode: 'VA'
	},
	{
		code: '+58',
		countryCode: 'VE'
	},
	{
		code: '+84',
		countryCode: 'VN'
	},
	{
		code: '+27',
		countryCode: 'ZA'
	}
];
